export function studyNodeWrapper(studyId, studyNodeName, node) {
    if (!studyId) {
        return node;
    } else {
        node.name = studyNodeName;
        node.args = {studyId, ...node.args};
        return node;
    }
}
